"use client"

import { SquarePlay } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquarePlayIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquarePlayIcon = component(Icon)({ as: SquarePlay })
